















import { Component, Prop, Provide, Vue } from 'vue-property-decorator'
import Router from 'vue-router'
import { getCurrentPath } from '../service/common'
import { USER_GROUPS } from '../service/constant'

@Component
export default class Breadcrumb extends Vue {
  private get menus() {
    return getCurrentPath(this.$route.path, this.$store.state[USER_GROUPS])
  }

  private removePrefix(url = '') {
    const PREFIX = '/csearch'
    if (url.startsWith(PREFIX)) {
      return url.slice(PREFIX.length)
    }
    return url
  }
}
